import { type Dispatch, type SetStateAction, useCallback, useState } from 'react';

import { shallowEqual } from 'fast-equals';

function useShallowState<T>(initialState: T | (() => T)): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(initialState);
  const setShallowState = useCallback((action: SetStateAction<T>) => {
    setState((prevState) => {
      const value = typeof action === 'function' ? (action as (prevState: T) => T)(prevState) : action;

      return shallowEqual(prevState, value) ? prevState : value;
    });
  }, []);
  return [state, setShallowState];
}

export default useShallowState;
